import React from "react";

/**
 * A wrapper that is used in the home page to wrap sections with common styling.
 *
 * @param {Object} props
 * @param {string} props.title - The title of the section
 * @param {string} props.id - The HTML id of the section
 * @param {JSX.Element | JSX.Element[]} props.children - The children of the component
 * @returns {JSX.Element}
 */

const HomeSection = ({ title, id, children }) => {
  return (
    <div className="px-6 pt-0 pb-5 md:px-12 md:pb-10" id={id}>
      <p className="font-bold mt-3 mb-7 text-[#E9B838c6] text-5xl">{title}</p>
      {children}
    </div>
  );
};

export default HomeSection;
